import React from 'react'

const Footer = (props) => {
  return (
    <div className={`text-center fixed-bottom py-3 bg-${props.theme==="dark"?"dark":"light"} text-${props.theme==="dark"?"light":"dark"}`}>Copyright &copy; {(new Date).getFullYear()} NoteBoss. All Right Reserved</div>
  )
}

export default Footer